import { render, staticRenderFns } from "./Purchase-Return.vue?vue&type=template&id=ad47f580"
import script from "./Purchase-Return.vue?vue&type=script&lang=js"
export * from "./Purchase-Return.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports